import * as scroll from '../../../../node_modules/disable-scroll.js/src/disable-scroll.js'

const OpenNav = ($nav) => {
  $nav.classList.add('--show')
  scroll.disabled()
}
const CloseNav = ($nav) => {
  $nav.classList.remove('--show')
  scroll.enabled()
}
const CloseHmInput = ($hmInput) => {
  $hmInput.checked = false
}

const Listeners = ($hmBtn, $hmInput, $nav) => {
  if (!$hmBtn) return

  $hmInput.addEventListener('change', (e) => {
    if (e.currentTarget.checked)  OpenNav($nav)
    if (!e.currentTarget.checked) CloseNav($nav)
  })
  $hmBtn.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  $nav.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  document.addEventListener('click', (e) => {
    if ($nav.classList.contains('--show')) {
      CloseNav($nav)
      CloseHmInput($hmInput)
    }
  })
  window.addEventListener('resize', (e) => {
    if (e.currentTarget.innerWidth >= 1024) {
      CloseNav($nav)
      CloseHmInput($hmInput)
    }
  })
  window.addEventListener('load', () => {
    setTimeout(() => {
      CloseNav($nav)
      CloseHmInput($hmInput)
    }, 50)
  })
}

const MobileNav = () => {
  const $hmBtn   = document.querySelector('header .hamburger-menu')
  const $hmInput = document.querySelector('header .hamburger-menu input')
  const $nav     = document.querySelector('.nav-side')

  Listeners($hmBtn, $hmInput, $nav)
}

export default MobileNav
